import { format, subHours } from '@@/js/utils/dateFns';

export const useEffectiveDate = () => {
    function getEffectiveDate(date, formatString = null) {
        const effectiveDate = subHours(date, 4);
        if (formatString) {
            return format(effectiveDate, formatString);
        }
        return format(effectiveDate, 'd MMMM yyyy');
    }

    function isToday(date) {
        return date === getEffectiveDate(new Date(), 'yyyy-MM-dd');
    }

    return {
        getEffectiveDate,
        isToday,
    };
};
